import { FC } from 'react'

import { Cluster, EmptyState } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

export const NotificationSelect: FC = () => {
  const { translate } = useLocalisation()

  return (
    <Cluster x="center" y="center">
      <EmptyState
        title={translate('notifications.empty.title')}
        description={translate('notifications.empty.description')}
      />
    </Cluster>
  )
}
